import { FC } from "react"
import { TravelersConfirmDelete } from "../../../module/travelers/containers/confirmDelete"

export const TravelersConfirmDeletePage: FC = () => <TravelersConfirmDelete />
